<template>
  <div class="pw-info-card" :class="classString">
    <i class="mdi mdi-information" />
    <span class="pw-info-card__detail" v-if="$slots.default">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    classString() {
      return this.type ? `pw-info-card__${this.type}` : '';
    },
  },
};
</script>

<style lang="scss">
.pw-info-card {
  display: flex;
  border-radius: 1px;
  padding: 7px;
  background: #dce7ff;
  font-size: 14px;
  &__detail {
    align-self: center;
  }
  .mdi {
    font-size: 17px;
    font-weight: initial;
    margin-right: 8px;
    color: #5186ff;
  }

  &__warn {
    color: #707070;
    background: #fff4da;

    .mdi {
      color: #ffc848;
    }
  }
  &__error {
    background: #f9c0c0;
    .mdi {
      color: #f25555;
    }
  }
  a {
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    color: #5185fe;
    &:hover {
      color: #5185fe;
      text-decoration: underline;
    }
  }
}
</style>
